/**
 * Whether a signature should be rendered beneath the given post in its current
 * view.
 *
 * Hidden (soft-deleted) posts don't show a signature unless the viewer has
 * revealed the post's content, and the author must actually have a signature.
 */
export default function shouldRenderSignatureOnPost(post, revealContent) {
  var _post$user;
  if (post.isHidden() && !revealContent) {
    return false;
  }
  const user = (_post$user = post.user) == null ? void 0 : _post$user.call(post);
  return Boolean(user && user.signature());
}
flarum.reg.add('fof-signature', 'forum/utils/signatureVisibility', shouldRenderSignatureOnPost);